
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { sleep } from "./utils/util";

// Mock Resend API Interface
export interface SendEmailOptions {
    from?: string;
    to: string;
    subject: string;
    html: string;
}

export const Resend = {
    emails: {
        /**
         * Simulates sending an email via Resend
         */
        send: async (options: SendEmailOptions) => {
            console.log(`[Resend] 📨 Sending email to ${options.to}`);
            await sleep(800); // Network delay
            
            // Log the email content to console for developer visibility
            console.group(`[Resend] Email Delivered`);
            console.log(`To: ${options.to}`);
            console.log(`Subject: ${options.subject}`);
            console.log(`Body: ${options.html.replace(/<[^>]*>?/gm, '')}`); // Strip tags for log
            console.groupEnd();

            return {
                id: `email_${Math.random().toString(36).slice(2)}`,
                error: null
            };
        }
    }
};
